import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useAlert } from "../contexts/AlertContext";
import { useNavigate } from "react-router-dom";
import SEO from "../components/SEO";
import "./login.css";

const Login = () => {
  const [isSignup, setIsSignup] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login, signup, user } = useAuth();
  const { showSuccess, showError } = useAlert();

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      let result;
      if (isSignup) {
        result = await signup(email, password, displayName);
        if (result.success) {
          showSuccess("Welcome to your musical journey! 🎵", 5000);
        }
      } else {
        result = await login(email, password);
        if (result.success) {
          showSuccess("Welcome back! 🎼", 4000);
        }
      }

      if (result.success) {
        navigate("/");
      } else {
        showError(result.error || "Authentication failed", 5000);
        setError(result.error || "Authentication failed");
      }
    } catch (err) {
      showError(errorMessage, 5000);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO
        title="Dashboard - Anjali Daswani Music"
        url="https://anjalidmusic.com/login"
        robots="noindex, nofollow"
      />
      <div className="login-page">
        <div className="login-container">
          <div className="login-card">
            <h1 className="login-title text-gradient">
              {isSignup ? "Create Account" : "Welcome Back"}
            </h1>
            <p className="login-subtitle">
              {isSignup
                ? "Sign up to access your dashboard"
                : "Sign in to access your dashboard"}
            </p>

            <form onSubmit={handleSubmit} className="login-form">
              {isSignup && (
                <div className="form-group">
                  <label htmlFor="displayName" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    id="displayName"
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    className="form-input"
                    placeholder="Your name"
                    required={isSignup}
                    disabled={loading}
                  />
                </div>
              )}

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  placeholder="your.email@example.com"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                  placeholder="••••••••"
                  required
                  disabled={loading}
                />
              </div>

              {error && <p className="error-message">{error}</p>}

              <button
                type="submit"
                className="btn-primary submit-btn"
                disabled={loading}
              >
                {loading ? "Processing..." : isSignup ? "Sign Up" : "Sign In"}
              </button>
            </form>

            <div className="login-footer">
              <p>
                {isSignup
                  ? "Already have an account?"
                  : "Don't have an account?"}
                <button
                  onClick={() => {
                    setIsSignup(!isSignup);
                    setError("");
                  }}
                  className="toggle-auth-btn"
                  disabled={loading}
                >
                  {isSignup ? "Sign In" : "Sign Up"}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
